import { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { notification, Tooltip } from 'antd';
import { format } from 'utils/date';
import { usePost, useAuth } from 'hooks';
import { tradeshowDownload } from 'services/api';
import { getFilters } from 'selectors/calendar';
import Export from 'components/Export';
import { downloadType } from 'components/Export/Summary/constants';
import { handleFailedExportNotification } from 'components/Search/Results/Actions/notifications';
import { DisabledButtonWrapper } from 'components/common/styled';
import { UpgradeLicense } from 'utils/constants';

const ExportTradeshowButton = ({ name, date }) => {
  const { user } = useAuth();
  const filters = useSelector(getFilters);
  const tradeshow = {
    label: date ? `${name} - ${format(date, 'YYYY')}` : name,
    date,
  };

  const [
    { res: tradeshowDownloadTriggered, error: tradeshowDownloadError },
    postTradeshowDownload,
  ] = usePost({
    url: tradeshowDownload,
  });

  useEffect(() => {
    if (tradeshowDownloadTriggered) {
      notification.open({
        message: 'Tradeshow Download Triggered',
        description: <div>Your tradeshow download has been requested.</div>,
        placement: 'bottomLeft',
      });
    }
  }, [tradeshowDownloadTriggered]);

  useEffect(() => {
    if (tradeshowDownloadError) {
      handleFailedExportNotification(tradeshowDownloadError.status);
    }
  }, [tradeshowDownloadError]);

  const getExportBody = () => ({
    tradeshowName: name,
    tradeshowYear: format(date, 'YYYY'),
    structuredSearch: JSON.stringify({
      ...filters,
      term: tradeshow.label,
      name: name,
    }),
  });

  const handleDownload = params => {
    const body = getExportBody();
    postTradeshowDownload({
      body: { ...body, ...params },
    });
  };

  const ButtonWrapper = user.isPartnerAccount
    ? DisabledButtonWrapper
    : Fragment;

  return (
    <Tooltip title={user.isPartnerAccount ? <UpgradeLicense /> : ''}>
      <ButtonWrapper>
        <Export
          downloadType={downloadType.tradeshowSearch}
          getQueryBody={getExportBody}
          onExport={handleDownload}
          disabled={user.isPartnerAccount}
        >
          Export Tradeshow Contacts
        </Export>
      </ButtonWrapper>
    </Tooltip>
  );
};

export default ExportTradeshowButton;
